/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboModifierSchema } from "./calculateDiscountComboModifierSchema.ts";

export const calculateDiscountComboGroupModifierSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(calculateDiscountComboModifierSchema),
});
